import axios from "axios";
import { authHeader } from "@/helpers/authHeader.js";
import { KUrls } from "@/helpers/constants";

export const einvoiceService = {
  getStatus,
};

const einvoiceEndpoint = KUrls.EINVOICE_ENDPOINT || "/einvoices";

async function getStatus(
  company,
  officeCode,
  minDatetimeIncl,
  maxDatetimeExcl,
  className
) {
  try {
    const authorization = authHeader();

    const response = await axios.get(
      `${KUrls.BASE_REST_URL}${einvoiceEndpoint}/${company}/status`,
      {
        headers: {
          // "Content-Type": "application/json",
          Authorization: authorization,
        },
        params: {
          officeCode: officeCode,
          minDatetimeIncl: minDatetimeIncl,
          maxDatetimeExcl: maxDatetimeExcl,
          className: className,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}
